import { useState, useRef } from 'react';
import { useField } from 'formik';
import { Form } from 'react-bootstrap';

export default function FileInput({
  label = 'Seleccionar archivo',
  children,
  groupClassName = '',
  onChange,
  ...props
}) {
  const [, , helpers] = useField(props);
  const [fileError, setFileError] = useState(false);
  const imgRef = useRef({});
  const customRender = useRef();

  const handleClick = () => {
    imgRef.current?.click();
  };

  const getFile = () => {
    setFileError(false);

    const [file] = imgRef.current.files;

    if (!file) return;

    if (file.size / 1024 >= 1024) {
      setFileError(true);
    } else {
      helpers.setValue(file);
      if (onChange) onChange(file);
    }
  };

  const fileInput = (
    <Form.File.Input
      accept=".jpg, .jpeg, .png, .gif"
      isInvalid={fileError}
      ref={imgRef}
      onChange={getFile}
      className={children ? 'd-none' : ''}
    />
  );

  return (
    <Form.Group controlId="formFile" className={groupClassName}>
      <Form.File id="custom-file" custom>
        {children ? (
          <>
            {fileInput}
            {children({
              ref: customRender,
              onClick: handleClick,
            })}
          </>
        ) : (
          <>
            {fileInput}
            <Form.File.Label data-browse="Explorar">{label}</Form.File.Label>
          </>
        )}
        {fileError && (
          <Form.Control.Feedback className="col-12" type="invalid">
            El tamaño del archivo debe ser menor a 1 MB
          </Form.Control.Feedback>
        )}
      </Form.File>
    </Form.Group>
  );
}
